import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

const DataCountList = ({ dataCounts, onEdit, onDelete }) => {
  return (
    <div className="table-container">
      <table className="data-table">
        <thead>
          <tr>
            <th>Data Type</th>
            <th>Total Count</th>
            <th>Description</th>
            <th>Type</th>
            <th>Page</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {dataCounts && dataCounts.length > 0 ? (
            dataCounts.map((data) => (
              <tr key={data.id}>
                <td>{data.data_type}</td>
                <td>{data.total_count}</td>
                <td>{data.description}</td>
                <td>{data.type}</td>
                <td>{data.page}</td>
                <td className="action-cell">
                  <button 
                    className="icon-btn edit-icon" 
                    onClick={() => onEdit(data.id)}
                    aria-label="Edit"
                    title="Edit"
                  >
                    <EditIcon fontSize="small" />
                  </button>
                  <button 
                    className="icon-btn delete-icon" 
                    onClick={() => onDelete(data.id)}
                    aria-label="Delete"
                    title="Delete"
                  >
                    <DeleteOutlineIcon fontSize="small" />
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" className="no-data-message">
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DataCountList;